var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg h-24 hlg:h-32 flex justify-end items-start px-4 pt-4 hlg:pt-10"},[_c('button',{staticClass:"text-white",on:{"click":_vm.closeModal}},[_c('XIcon',{staticClass:"w-8 h-8"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }